import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=70b91bff"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=70b91bff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports